import { createSelector } from '@reduxjs/toolkit';

import { selectFeatureFlags } from '@/redux/featureFlag/selectors';
import { checkPermission, selectPermissionsState } from '@/redux/permissions/selectors';
import { actions } from '@/shared/types/permissions';

import { DEVELOPER_MODULES } from './constants';

export const selectReadableDeveloperModules = createSelector(
  [selectPermissionsState, selectFeatureFlags],
  (permissions, featureFlags) =>
    DEVELOPER_MODULES.filter(
      (module) =>
        (module !== 'speech_models' || featureFlags.speech_strategy) &&
        checkPermission(permissions, module, actions.READ)
    )
);
